A page of candidate process history items.
